import type { SNACKBAR_ITEM_VARIANT } from '@george-labs.com/design-system/types/components/Snackbar';
import { SnackbarItem } from '@george-labs.com/design-system';

import { uuid } from '@luna/utils';

import type { SnackItem, SnackbarButtonProps } from './SnackItem';

type HideMessage = () => void;

export const displayMessage = (
    addItem: (item: SnackItem) => void,
    removeItem: (snackItemId: string) => void,
    dataCy: string,
    message: string,
    variant: SNACKBAR_ITEM_VARIANT,
    buttonProps?: SnackbarButtonProps,
    autoCloseable = SnackbarItem.AUTO_CLOSEABLE.ENABLED,
): HideMessage => {
    const item = {
        id: uuid(),
        'data-cy': dataCy,
        type: variant,
        message,
        buttonProps,
        autoCloseable,
    };
    addItem(item);

    return () => {
        removeItem(item.id);
    };
};
